import React, { Component } from "react";
import { connect } from "react-redux";
import { ShowVisibleNextAtd } from "../actions";

const mapStateToProps = (state) => {
  return {
    DisplayNextAtd: state.displaynextatd,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowVisibleNextAtdIn: (post, temp) => {
    dispatch(ShowVisibleNextAtd(post, temp));
  },
});

class QueueSlim extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: " active" };
  }

  ShowVisible() {
    this.props.ShowVisibleNextAtdIn(true, true);
  }

  render() {
    const { DisplayNextAtd, screen } = this.props;

    if (DisplayNextAtd.length != 0) {
      if (
        DisplayNextAtd.displaynextatd === true ||
        DisplayNextAtd.displaynextatd === "ocultar"
      ) {
        this.state.visible = "";
      } else if (DisplayNextAtd.displaynextatd === false) {
        this.state.visible = " active";
      } else {
        this.state.visible = " active";
      }
    }

    return (
      <div
        className={"prox-atend--slim w-5" + this.state.visible}
        onClick={(event) => this.ShowVisible(event)}
      >
        <span className="prox-atend--slim__tool-tip tool-tip">Exibir</span>
        <span className="prox-atend--slim__icon material-icons">
          arrow_forward
        </span>
        <p className="prox-atend--slim__text is-poppins is-poppins--bold">
          Próximos atendimentos
        </p>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QueueSlim);
